module.exports = __webpack_public_path__ + "img/vr_m_6.6b18fcb9.jpg";